// 各组件的z-index值
export default {
  landsacpe: 29100,
  navbar: 29090,
  toast: 20090,
  goodsNav: 20089,
  alert: 20085,
  modal: 20080,
  popup: 20075,
  tips: 19080,
  sticky: 19075,
  indexListSticky: 19070,
  fab: 19060,
  mask: 9999,
  tableTr: 1001,
  tableTd: 1000
}